import React, { useContext, useState, useEffect, useLayoutEffect } from 'react';
import {
  Widget,
  FormSelect,
  SimpleView,
  MasterDetailForm,
  GridView,
  Row,
  InlineEditTable,
  InlineEditColumnProps,
} from '@digital/ui';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';
import { Collapse, Icon, Input } from 'antd';
import { ProjetoPacote } from '@app/api/projeto';
import { AcronimoPacote } from '@app/api/acronimosPacote';
import { OrcamentoAcronimoPacote } from '@app/api/ordemInvestimento';

interface FormProjetoProps {
  acronimos: { text: string; value: string; }[] | undefined;
  projetoPa: ProjetoPacote[];
  handleUpdate: (record: OrcamentoAcronimoPacote) => void;
}

const { Panel } = Collapse;

const FormProjetoPacote = (props: FormProjetoProps) => {
  const { acronimos, projetoPa, handleUpdate } = props;
  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'Oi',
        dataIndex: 'pacoteOiOi',
        width: '2%',
      },
      {
        title: 'Código',
        dataIndex: 'pacoteOiCodigo',
        width: '13%',
      },
      {
        title: 'Nome',
        dataIndex: 'pacoteOiNome',
        width: '35%',
      },
      {
        title: 'Situação',
        dataIndex: 'situacao',
        width: '1%',
      },
      {
        title: 'RFA',
        dataIndex: 'possuiRfa',
        width: '1%',
      },
      {
        title: 'Acrônimo',
        dataIndex: 'acronimoId',
        key: 'acronimoId',
        options: acronimos,
        width: '7%',
        render: (_: string, record: AcronimoPacote) => {
          const option = acronimos && acronimos.find(f => f.value === record.acronimoId);
          return option ? option.text : '';
        },
        renderEdit: () => <FormSelect name="acronimoId" options={acronimos} required disabled={false} allowClear />,
      },
      {
        title: 'Data',
        dataIndex: 'ultimaAtualizacao',
        width: '15%',
      },
      {
        title: 'Responsável',
        dataIndex: 'matriculaResponsavel',
        width: '25%',
      },
    ] as InlineEditColumnProps<ProjetoPacote>[];
  };

  return (
    <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="2" header="Lista de pacotes do projeto" style={{ border: 0 }}>
        <MasterDetailForm>
          <Widget actions={[]}>
            <Row>
              <InlineEditTable
                rowKey="index"
                columns={customColumns()}
                updateItem={handleUpdate}
                dataSource={projetoPa || []}
                pagination={false}
                disablenotification={false}
              />
            </Row>
          </Widget>
        </MasterDetailForm>
      </Panel>
    </Collapse>
  );
};

export default FormProjetoPacote;
